import { create } from 'zustand';

interface AuthGateState {
  /** Коли саме сервер відповів 401. null — усе гаразд. */
  expiredAt: number | null;
  markExpired: () => void;
  clear: () => void;
}

/**
 * Прапорець «сесія протухла».
 *
 * Реакція на 401 навмисно розділена на дві частини:
 *  1) http-шар лише повідомляє факт (`onUnauthorized`);
 *  2) UI переводить дитину на екран входу.
 *
 * Чого тут НЕМАЄ і бути не може — очищення офлайн-черги.
 * Відповіді дитини переживають вихід із акаунта і поїдуть після нового входу.
 */
export const useAuthGate = create<AuthGateState>((set) => ({
  expiredAt: null,
  markExpired: () => set({ expiredAt: Date.now() }),
  clear: () => set({ expiredAt: null }),
}));
